import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ColumnComponent } from '../column.component';
import { type SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';
import { SectionColumnConfigProductInfoKey } from 'src/app/models/enum/shared/section-column-config-product-info-key';

@Component({
  selector: 'app-column-top-flavor',
  imports: [AsyncPipe, SharedModule],
  templateUrl: './column-top-flavor.component.html',
  styleUrl: './column-top-flavor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnTopFlavorComponent extends ColumnComponent {
  constructor() {
    super();
  }

  @Input() useNgContent: boolean;
  @Input() displayFormat: SectionColumnConfigDataValue;

  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnConfigProductInfoKey.TopFlavor)?.image;
    }
    return this.rowVm.getTopFlavorPlainText();
  }
}
